import script from "./sqProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./sqProduct.vue?vue&type=script&setup=true&lang=js"

import "./sqProduct.vue?vue&type=style&index=0&id=3d93c13c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d93c13c"]])

export default __exports__